export default __webpack_public_path__ + "static/media/FinsImg.1b4c6421.jpg";